import { useReducer } from 'react';
export const useToggle = (initialValue) => {
    return useReducer((state, nextValue) => (nextValue ? nextValue : !state), initialValue);
};
//# sourceMappingURL=useToggle.js.map